/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

import { createSlice } from "@reduxjs/toolkit";
import { formQuestionsState } from "./form-questions.state";

const formQuestionsSlice = createSlice({
    name: "formQuestions",
    initialState: formQuestionsState,
    reducers: {
        setQuestions (state, action) {
            const { questions, webpage } = action.payload;
            state.questions = questions;
            state.webpage = webpage;
        }
    }
});

export const formQuestionsReducer = formQuestionsSlice.reducer;

export const {
    setQuestions
} = formQuestionsSlice.actions; 